import {
  Box,
  Grid,
  createTheme,
  ThemeProvider,
  Menu,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Chip,
  Autocomplete,
  TextField,
  CircularProgress,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import React, { useEffect, useState, useCallback, useRef } from "react";
import Button from "@mui/material/Button";
import { format, subDays, startOfMonth, endOfMonth, subMonths } from "date-fns";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import MenuItem from "@mui/material/MenuItem";
import MUIDataTable from "mui-datatables";
import MoreHorizTwoToneIcon from "@mui/icons-material/MoreHorizTwoTone";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { useNavigate } from "react-router-dom";
import StatusAlert from "../../StatusAlertList/StatusAlert";
import config from "../../Data/AuthUser";
import { TripsApi, clientApis, clientDriversApis, DriverApis } from "../../Data/axios";
import { toZonedTime } from "date-fns-tz";
import { useSelector } from "react-redux";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const HeaderTrips = ({
  searchValue,
  handleSearchChange,
  searchInputRef,
  statusFilter,
  setStatusFilter,
  dateFilterType,
  setDateFilterType,
  selectedStartDate,
  setSelectedStartDate,
  selectedEndDate,
  setSelectedEndDate,
  showStatusDropdown,
  setShowStatusDropdown,
  showDateDropdown,
  setShowDateDropdown,
  handleDateRangeApply,
  clearFilters,
  statusOptions,
  datePresets,
  getDateRangeLabel,
}) => {
  return (
    <div style={{ background: "white", borderBottom: "1px solid #e0e0e0", padding: "20px 0", marginBottom: "24px" }}>
      <div style={{ maxWidth: "100%", margin: "0 auto", padding: "0 24px" }}>
        <div style={{ marginBottom: "24px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div>
            <h2 style={{ margin: "0 0 8px 0", fontSize: "28px", fontWeight: 700, color: "#1a1a1a" }}>Trips</h2>
            <p style={{ margin: 0, fontSize: "14px", color: "#666" }}>Manage and monitor all trip activities</p>
          </div>
        </div>

        {(statusFilter !== "all" || dateFilterType !== "all") && (
          <div style={{ marginBottom: "16px", display: "flex", flexWrap: "wrap", gap: "8px", alignItems: "center" }}>
            {statusFilter !== "all" && (
              <Chip
                label={`Status: ${statusOptions.find((s) => s.value === statusFilter)?.label}`}
                onDelete={() => setStatusFilter("all")}
                size="small"
                sx={{ backgroundColor: "#f3e5f5", color: "#7b1fa2" }}
              />
            )}
            {dateFilterType !== "all" && (
              <Chip
                label={`Date: ${getDateRangeLabel()}`}
                onDelete={() => {
                  setDateFilterType("all");
                  setSelectedStartDate("");
                  setSelectedEndDate("");
                }}
                size="small"
                sx={{ backgroundColor: "#e8f5e9", color: "#388e3c" }}
              />
            )}
            <Button size="small" startIcon={<ClearIcon />} onClick={clearFilters} sx={{ color: "#d32f2f" }}>
              Clear All
            </Button>
          </div>
        )}

        <div style={{ display: "flex", gap: "16px", alignItems: "flex-end", flexWrap: "wrap", position: "relative" }}>
          <div style={{ flex: "1 1 280px", minWidth: "220px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
              <label style={{ fontSize: "12px", fontWeight: 600, color: "#666", textTransform: "uppercase", letterSpacing: "0.5px" }}>Search</label>
            </div>
            <div data-dropdown="search" style={{ position: "relative", display: "flex", alignItems: "center", backgroundColor: "#f5f5f5", border: "1px solid #e0e0e0", borderRadius: "8px", padding: "0 12px" }}>
              <SearchIcon sx={{ fontSize: 18, color: "#999", marginRight: "8px" }} />
              <input
                ref={searchInputRef}
                type="text"
                placeholder="Type driver or owner name/ID..."
                value={searchValue}
                onChange={handleSearchChange}
                style={{ flex: 1, border: "none", outline: "none", padding: "10px 0", fontSize: "14px", backgroundColor: "transparent", color: "#333" }}
              />
            </div>
          </div>

          <div style={{ flex: "1 1 180px", minWidth: "150px", position: "relative" }} data-dropdown="status">
            <label style={{ display: "block", fontSize: "12px", fontWeight: 600, color: "#666", marginBottom: "8px", textTransform: "uppercase" }}>Status</label>
            <button
              onClick={() => { setShowStatusDropdown(!showStatusDropdown); setShowDateDropdown(false); }}
              style={{ width: "100%", padding: "10px 12px", border: "1px solid #e0e0e0", borderRadius: "8px", fontSize: "14px", backgroundColor: showStatusDropdown ? "#e3f2fd" : "white", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between" }}
            >
              <span>{statusOptions.find((s) => s.value === statusFilter)?.label || "Select Status"}</span>
              <svg style={{ width: "16px", height: "16px", transform: showStatusDropdown ? "rotate(180deg)" : "rotate(0)" }} viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </button>
            {showStatusDropdown && (
              <div style={{ position: "absolute", top: "100%", left: 0, right: 0, marginTop: "8px", backgroundColor: "white", border: "1px solid #e0e0e0", borderRadius: "8px", boxShadow: "0 4px 16px rgba(0,0,0,0.1)", zIndex: 1001 }}>
                {statusOptions.map((option) => (
                  <button
                    key={option.value}
                    onClick={() => { setStatusFilter(option.value); setShowStatusDropdown(false); }}
                    style={{ width: "100%", padding: "12px 16px", border: "none", backgroundColor: statusFilter === option.value ? "#e3f2fd" : "white", color: statusFilter === option.value ? "#2196f3" : "#333", cursor: "pointer", textAlign: "left", fontSize: "14px" }}
                  >
                    {option.label}
                  </button>
                ))}
              </div>
            )}
          </div>

          <div style={{ flex: "1 1 180px", minWidth: "150px", position: "relative" }} data-dropdown="date">
            <label style={{ display: "block", fontSize: "12px", fontWeight: 600, color: "#666", marginBottom: "8px", textTransform: "uppercase" }}>Date Range</label>
            <button
              onClick={() => { setShowDateDropdown(!showDateDropdown); setShowStatusDropdown(false); }}
              style={{ width: "100%", padding: "10px 12px", border: "1px solid #e0e0e0", borderRadius: "8px", fontSize: "14px", backgroundColor: showDateDropdown ? "#e3f2fd" : "white", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between" }}
            >
              <span>{getDateRangeLabel()}</span>
              <svg style={{ width: "16px", height: "16px", transform: showDateDropdown ? "rotate(180deg)" : "rotate(0)" }} viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </button>
            {showDateDropdown && (
              <div style={{ position: "absolute", top: "100%", left: 0, right: 0, marginTop: "8px", backgroundColor: "white", border: "1px solid #e0e0e0", borderRadius: "8px", boxShadow: "0 4px 16px rgba(0,0,0,0.1)", zIndex: 1001, minWidth: "320px", padding: "16px" }}>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px", marginBottom: "16px" }}>
                  {datePresets.map((preset) => (
                    <button
                      key={preset.value}
                      onClick={() => { setDateFilterType(preset.value); setShowDateDropdown(false); }}
                      style={{ padding: "8px", border: "1px solid #e0e0e0", borderRadius: "6px", fontSize: "12px", cursor: "pointer", backgroundColor: dateFilterType === preset.value ? "#2196f3" : "white", color: dateFilterType === preset.value ? "white" : "#333" }}
                    >
                      {preset.label}
                    </button>
                  ))}
                </div>
                <div style={{ borderTop: "1px solid #e0e0e0", paddingTop: "16px" }}>
                  <input type="date" value={selectedStartDate} onChange={(e) => setSelectedStartDate(e.target.value)} style={{ width: "100%", marginBottom: "8px", padding: "8px", border: "1px solid #e0e0e0", borderRadius: "6px" }} />
                  <input type="date" value={selectedEndDate} onChange={(e) => setSelectedEndDate(e.target.value)} style={{ width: "100%", marginBottom: "12px", padding: "8px", border: "1px solid #e0e0e0", borderRadius: "6px" }} />
                  <button onClick={handleDateRangeApply} style={{ width: "100%", padding: "10px", backgroundColor: "#2196f3", color: "white", border: "none", borderRadius: "6px", cursor: "pointer", fontWeight: 600 }}>Apply Range</button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

function Trips() {
  const isTestUser = useSelector((state) => state?.user?.isTestUser);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [openAddTrip, setOpenAddTrip] = useState(false);
  const [addTripData, setAddTripData] = useState({
    user_id: "", driver_id: "", vehicle_id: "", start_location: "", end_location: "", start_date: "", time: ""
  });
  const [clients, setClients] = useState([]);
  const [loadingClients, setLoadingClients] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [drivers, setDrivers] = useState([]);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [loadingDrivers, setLoadingDrivers] = useState(false);
  const [savingTrip, setSavingTrip] = useState(false);
  const [startLocOptions, setStartLocOptions] = useState([]);
  const [loadingStartLoc, setLoadingStartLoc] = useState(false);
  const [endLocOptions, setEndLocOptions] = useState([]);
  const [loadingEndLoc, setLoadingEndLoc] = useState(false);

  // APIs for autocomplete
  const fetchClients = useCallback(async (query) => {
    setLoadingClients(true);
    try {
      const res = await clientApis.getAll(1, 50, "company_name", query);
      if (res && res.data && res.data.data) {
        setClients(res.data.data);
      } else if (res && res.data) {
        setClients(res.data);
      }
    } catch (err) { }
    setLoadingClients(false);
  }, []);

  const fetchDrivers = useCallback(async (clientId) => {
    setLoadingDrivers(true);
    setDrivers([]);
    setSelectedDriver(null);
    setAddTripData(prev => ({ ...prev, driver_id: "" }));
    console.log("fetchDrivers called with input clientId:", clientId);
    try {
      const res = await clientDriversApis.getClientDriversList(clientId);
      console.log("fetchDrivers response:", res);
      if (res && res.data && res.data.active_drivers) {
        setDrivers(res.data.active_drivers);
      } else if (res && res.active_drivers) {
        setDrivers(res.active_drivers);
      }
    } catch (err) {
      console.error("fetchDrivers error:", err);
    }
    setLoadingDrivers(false);
  }, []);

  const searchCities = async (query, setOptions, setLoading) => {
    if (!query || query.length < 3) return;
    setLoading(true);
    try {
      const res = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}&featuretype=city`);
      const data = await res.json();
      setOptions(data.map(item => item.name || item.display_name.split(',')[0].trim()));
    } catch (err) { }
    setLoading(false);
  };

  const handleAddTripSubmit = async () => {
    const { user_id, driver_id, vehicle_id, start_location, end_location, start_date, time } = addTripData;
    if (!user_id || !driver_id || !vehicle_id || !start_location || !end_location || !start_date || !time) {
      showAlert("All fields are required", "error");
      return;
    }
    setSavingTrip(true);
    const res = await TripsApi.createTripFromDashboard(addTripData);
    if (res.success) {
      showAlert("Trip created successfully", "success");
      setOpenAddTrip(false);
      setAddTripData({ user_id: "", driver_id: "", vehicle_id: "", start_location: "", end_location: "", start_date: "", time: "" });
      setClients([]);
      setSelectedClient(null);
      setDrivers([]);
      setSelectedDriver(null);
      getData(currentPage, rowsPerPage, searchValue);
    } else {
      showAlert(res.message || "Failed to create trip", "error");
    }
    setSavingTrip(false);
  };
  const [tripsData, setTripsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingStage, setLoadingStage] = useState('fetching');
  const [pagination, setPagination] = useState({
    current_page: 1,
    per_page: 5,
    total_records: 0,
    total_pages: 1,
  });

  const [searchValue, setSearchValue] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [dateFilterType, setDateFilterType] = useState("all");
  const [selectedStartDate, setSelectedStartDate] = useState("");
  const [selectedEndDate, setSelectedEndDate] = useState("");
  const [showDateDropdown, setShowDateDropdown] = useState(false);
  const [showStatusDropdown, setShowStatusDropdown] = useState(false);

  // FIXED: Track active row for menu
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeRow, setActiveRow] = useState(null);

  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");

  const searchInputRef = useRef(null);
  const navigate = useNavigate();

  const showAlert = (message, severity) => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };

  const [liveStatus, setLiveStatus] = useState({});

  const getLiveBadge = (status) => {
    switch (status) {
      case "moving":
        return { label: "Moving", color: "#2e7d32", bg: "#e8f5e9" };
      case "rest":
        return { label: "Rest", color: "#ed6c02", bg: "#fff3e0" };
      case "offline":
        return { label: "Offline", color: "#757575", bg: "#eeeeee" };
      default:
        return null;
    }
  };

  const fetchLiveStatuses = useCallback(async (trips) => {
    if (!trips || trips.length === 0) return;
    const tripIds = trips.map((t) => t?.id).filter(Boolean);
    const userIds = trips.map((t) => t?.driver_id).filter(Boolean);
    const data = await DriverApis.getLiveStatus({ tripIds, userIds });

    // Newer backend keys by trip_id; older backend keys by user_id.
    // Normalize everything to trip_id keys so the table can look up by trip id.
    const merged = {};
    trips.forEach((t) => {
      if (t?.id == null) return;
      const byTrip = data[t.id];
      if (byTrip) merged[t.id] = byTrip;
    });
    Object.values(data).forEach((entry) => {
      if (!entry || entry.trip_id == null) return;
      const trip = trips.find((t) => String(t.id) === String(entry.trip_id));
      if (trip) merged[trip.id] = entry;
    });

    // A driver is on one trip at a time — keep only their most recent status
    // so a driver's past trips never carry a badge.
    const byDriver = {};
    Object.values(merged).forEach((entry) => {
      if (!entry || entry.user_id == null) return;
      const cur = byDriver[entry.user_id];
      if (!cur || String(entry.last_seen_at || "") > String(cur.last_seen_at || "")) {
        byDriver[entry.user_id] = entry;
      }
    });

    // Fallback for the legacy backend (keys by user_id, no trip_id):
    // assign the driver's status to their most recent trip on this page.
    const driverLatestTrip = {};
    trips.forEach((t) => {
      if (t?.driver_id == null) return;
      const cur = driverLatestTrip[t.driver_id];
      const ts = String(t.updated_at || t.created_at || "");
      if (!cur || ts > String(cur.updated_at || cur.created_at || "")) {
        driverLatestTrip[t.driver_id] = t;
      }
    });

    const filtered = {};
    trips.forEach((t) => {
      if (t?.id == null) return;
      const e = byDriver[t?.driver_id];
      if (!e) return;
      if (String(e.trip_id) === String(t.id)) {
        filtered[t.id] = e;
      } else if (e.trip_id == null && driverLatestTrip[t.driver_id]?.id === t.id) {
        filtered[t.id] = e;
      }
    });
    setLiveStatus(filtered);
  }, []);

  useEffect(() => {
    if (tripsData.length > 0) fetchLiveStatuses(tripsData);
  }, [tripsData, fetchLiveStatuses]);

  useEffect(() => {
    if (tripsData.length === 0) return;
    const timer = setInterval(() => fetchLiveStatuses(tripsData), 30000);
    return () => clearInterval(timer);
  }, [tripsData, fetchLiveStatuses]);


  const formatDateForApi = (date) => format(new Date(date), "yyyy-MM-dd");

  const getData = useCallback(async (page, limit, searchTerm = "") => {
    try {
      setLoading(true);
      setLoadingStage('fetching');

      const params = {
        page: page,
        limit: limit,
        ...(searchTerm.length >= 3 && { search: searchTerm }),
        ...(statusFilter !== "all" && { status: statusFilter }),
      };

      if (dateFilterType !== "all" && dateFilterType !== "custom") {
        const today = new Date();
        let startDate = new Date();
        switch (dateFilterType) {
          case "today": params.date = formatDateForApi(today); break;
          case "last30": startDate = subDays(today, 30); params.start_date = formatDateForApi(startDate); params.end_date = formatDateForApi(today); break;
          case "thisMonth": startDate = startOfMonth(today); params.start_date = formatDateForApi(startDate); params.end_date = formatDateForApi(today); break;
          case "lastMonth": startDate = startOfMonth(subMonths(today, 1)); params.start_date = formatDateForApi(startDate); params.end_date = formatDateForApi(endOfMonth(subMonths(today, 1))); break;
          case "last90": startDate = subDays(today, 90); params.start_date = formatDateForApi(startDate); params.end_date = formatDateForApi(today); break;
          case "last6months": startDate = subMonths(today, 6); params.start_date = formatDateForApi(startDate); params.end_date = formatDateForApi(today); break;
          case "lastYear": startDate = subMonths(today, 12); params.start_date = formatDateForApi(startDate); params.end_date = formatDateForApi(today); break;
        }
      } else if (dateFilterType === "custom" && selectedStartDate && selectedEndDate) {
        params.start_date = selectedStartDate;
        params.end_date = selectedEndDate;
      }

      // For test users, specifically request only the latest 5 trips
      if (isTestUser) {
        params.limit = 5;
        params.page = 1;
      }

      setLoadingStage('analyzing');

      const response = await TripsApi.getTripsForDashboard("admin", params);
      if (response.success) {
        let tripsData = response.data || [];

        setLoadingStage('rendering');

        // For test users, ensure we only have the latest 5 trips
        if (isTestUser) {
          if (tripsData.length > 5) {
            tripsData = tripsData.slice(0, 5);
          }
          setPagination({
            current_page: 1,
            per_page: 5,
            total_records: Math.min(tripsData.length, 5),
            total_pages: 1,
          });
        } else {
          setPagination({
            current_page: response.currentPage,
            per_page: limit,
            total_records: response.totalRecords,
            total_pages: response.totalPages,
          });
        }

        setTripsData(tripsData);
      }
    } catch (error) {
      console.error("Error fetching trips:", error);
    } finally {
      setLoading(false);
    }
  }, [statusFilter, dateFilterType, selectedStartDate, selectedEndDate, isTestUser]);

  // FIXED: Unified effect for search and filters
  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchValue.length === 0 || searchValue.length >= 3) {
        getData(currentPage, rowsPerPage, searchValue);
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [searchValue, currentPage, rowsPerPage, statusFilter, dateFilterType, selectedStartDate, selectedEndDate, getData]);

  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
    setCurrentPage(1); // Reset to first page on search
  };

  const handleDateRangeApply = () => {
    if (selectedStartDate && selectedEndDate) {
      setDateFilterType("custom");
      setCurrentPage(1);
      setShowDateDropdown(false);
    } else {
      showAlert("Please select both dates", "warning");
    }
  };

  const clearFilters = () => {
    setSearchValue("");
    setStatusFilter("all");
    setDateFilterType("all");
    setSelectedStartDate("");
    setSelectedEndDate("");
    setCurrentPage(1);
  };

  const statusOptions = [
    { label: "All Status", value: "all" },
    { label: "Cancelled", value: "0" },
    { label: "Created", value: "1" },
    { label: "Started", value: "2" },
    { label: "Completed", value: "3" },
  ];

  const datePresets = [
    { label: "Today", value: "today" },
    { label: "Last 30 Days", value: "last30" },
    { label: "This Month", value: "thisMonth" },
    { label: "Last Month", value: "lastMonth" },
    { label: "Last 90 Days", value: "last90" },
    { label: "Last 6 Months", value: "last6months" },
    { label: "Last Year", value: "lastYear" },
  ];

  const getDateRangeLabel = () => {
    if (dateFilterType === "custom" && selectedStartDate) return `${selectedStartDate} to ${selectedEndDate}`;
    return datePresets.find((p) => p.value === dateFilterType)?.label || "All Time";
  };

  const tripStatus = (value) => {
    const statusMap = {
      0: { label: "Cancelled", color: "#d32f2f" },
      1: { label: "Created", color: "#f57c00" },
      2: { label: "Started", color: "#1976d2" },
      3: { label: "Completed", color: "#388e3c" },
    };
    const status = statusMap[parseInt(value)] || { label: "Unknown", color: "#9e9e9e" };
    return <span style={{ color: status.color, fontWeight: 600, fontSize: "13px" }}>{status.label}</span>;
  };

  const handleOpenMenu = (event, rowData) => {
    setAnchorEl(event.currentTarget);
    setActiveRow(rowData);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setActiveRow(null);
  };

  const columns = [
    {
      name: "verification_code",
      label: "Verification Code",
      options: {
        customBodyRender: (value) => <div style={{ textAlign: "center", fontSize: "14px", fontWeight: 500 }}>{value || "N/A"}</div>
      }
    },

    {
      name: "driver_username",
      label: "Driver Name",
      options: {
        customBodyRender: (value, tableMeta) => {
          const fullRecord = tripsData[tableMeta.rowIndex];
          if (!fullRecord) return null;
          const imageUrl = fullRecord.driver_image && fullRecord.driver_image !== "non"
            ? `${config.apiImageUrl}${fullRecord.driver_image}`
            : "/default-avatar.png";
          return (
            <div style={{ display: "flex", alignItems: "center", padding: "8px 0" }}>
              <img src={imageUrl} alt="driver" style={{ width: "40px", height: "40px", borderRadius: "50%", objectFit: "cover", marginRight: "12px", border: "1px solid #e0e0e0" }} />
              <div>
                <div style={{ fontWeight: 600, fontSize: "14px" }}>{fullRecord.driver_username || "N/A"}</div>
                <div style={{ color: "#666", fontSize: "12px" }}>ID: {fullRecord.driver_id || ""}</div>
              </div>
            </div>
          );
        },
      },
    },
    {
      name: "owner_username",
      label: "Owner Name",
      options: {
        customBodyRender: (value, tableMeta) => {
          const fullRecord = tripsData[tableMeta.rowIndex];
          return (
            <div style={{ padding: "8px 0" }}>
              <div style={{ fontWeight: 600, fontSize: "14px" }}>{fullRecord?.owner_username || "N/A"}</div>
              <div style={{ color: "#666", fontSize: "12px" }}>{fullRecord?.user_id || ""}</div>
            </div>
          );
        },
      },
    },
    {
      name: "start_location",
      label: "Location",
      options: {
        customBodyRender: (value, tableMeta) => {
          const fullRecord = tripsData[tableMeta.rowIndex];
          return (
            <div style={{ fontSize: "13px", padding: "8px 0" }}>
              <div><strong>From:</strong> {fullRecord?.start_location || "N/A"}</div>
              <div style={{ color: "#666" }}><strong>To:</strong> {fullRecord?.end_location || "N/A"}</div>
            </div>
          );
        },
      },
    },
    {
      name: "vehicle_id",
      label: "Vehicle No",
      options: {
        customBodyRender: (value) => <div style={{ textAlign: "center", fontSize: "14px", fontWeight: 500 }}>{value || "N/A"}</div>
      }
    },
    {
      name: "status",
      label: "Status",
      options: {
        customBodyRender: (value) => <div style={{ textAlign: "center" }}>{tripStatus(value)}</div>
      }
    },
    {
      name: "live_status",
      label: "Live Status",
      options: {
        customBodyRender: (value, tableMeta) => {
          const fullRecord = tripsData[tableMeta.rowIndex];
          const entry = fullRecord?.id ? liveStatus[fullRecord.id] : null;
          const badge = getLiveBadge(entry?.live_status);
          return (
            <div style={{ textAlign: "center" }}>
              {badge ? (
                <Chip
                  label={badge.label}
                  size="small"
                  sx={{
                    fontSize: "11px",
                    height: "22px",
                    color: badge.color,
                    backgroundColor: badge.bg,
                  }}
                />
              ) : (
                <span style={{ color: "#999", fontSize: "13px" }}>—</span>
              )}
            </div>
          );
        },
      },
    },
    {
      name: "updated_at",
      label: "Time",
      options: {
        customBodyRender: (value, tableMeta) => {
          const fullRecord = tripsData[tableMeta.rowIndex];
          const status = parseInt(fullRecord?.status);

          if (!value) {
            return <div style={{ textAlign: "center", fontSize: "13px" }}>N/A</div>;
          }

          const getStatusBadge = (status) => {
            switch (status) {
              case 1:
                return { label: "Created", color: "#1976d2", bg: "#e3f2fd" };
              case 2:
                return { label: "Started", color: "#ed6c02", bg: "#fff3e0" };
              case 3:
                return { label: "Completed", color: "#2e7d32", bg: "#e8f5e9" };
              case 0:
                return { label: "Canceled", color: "#d32f2f", bg: "#fdecea" };
              default:
                return null;
            }
          };

          const badge = getStatusBadge(status);

          // Convert UTC → Local
          const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
          const utcDate = new Date(value.replace(" ", "T") + "Z");
          const localDate = toZonedTime(utcDate, userTimeZone);

          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px"
              }}
            >
              {/* Time Block */}
              <div style={{ textAlign: "right" }}>
                <div style={{ fontWeight: 600, fontSize: "13px" }}>
                  {format(localDate, "dd-MM-yyyy")}
                </div>
                <div style={{ color: "#666", fontSize: "12px" }}>
                  {format(localDate, "HH:mm:ss")}
                </div>
              </div>

              {/* Status Chip */}
              {badge && (
                <Chip
                  label={badge.label}
                  size="small"
                  sx={{
                    fontSize: "11px",
                    height: "22px",
                    color: badge.color,
                    backgroundColor: badge.bg,
                  }}
                />
              )}
            </div>
          );
        }
      }
    },
    {
      name: "first_recorded_at",
      label: "Start Time",
      options: {
        customBodyRender: (value, tableMeta) => {
          const fullRecord = tripsData[tableMeta.rowIndex];
          if (!value) return <div style={{ textAlign: "center", fontSize: "13px" }}>N/A</div>;

          // Convert UTC → Local
          const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
          const utcDate = new Date(value.replace(" ", "T") + "Z");
          const localDate = toZonedTime(utcDate, userTimeZone);

          return (
            <div style={{ textAlign: "center", fontSize: "13px" }}>
              <div style={{ fontWeight: 600 }}>{format(localDate, "dd-MM-yyyy")}</div>
              <div style={{ color: "#666" }}>{format(localDate, "HH:mm:ss")}</div>
            </div>
          );
        }
      }
    },
    {
      name: "id",
      label: "Action",
      options: {
        customBodyRender: (value, tableMeta) => {
          const fullRecord = tripsData[tableMeta.rowIndex];
          return (
            <div style={{ textAlign: "right" }}>
              <IconButton onClick={(e) => { e.stopPropagation(); handleOpenMenu(e, fullRecord); }}>
                <MoreHorizTwoToneIcon />
              </IconButton>
            </div>
          );
        }
      }
    }
  ];

  const options = {
    selectableRows: "none",
    responsive: "standard",
    elevation: 0,
    serverSide: true,
    count: pagination.total_records,
    page: currentPage - 1, // FIXED: Sync with React state
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: isTestUser ? [5] : [5, 10, 25, 50], // Limit rows per page options for test users
    setRowProps: () => ({ style: { cursor: "pointer" } }),
    onRowClick: (rowData, rowMeta) => {
      const record = tripsData[rowMeta.dataIndex];
      if (record) {
        navigate(`/trip_details/${record.id}`, {
          state: { driver_id: record.driver_id }
        });
      }
    },
    onTableChange: (action, tableState) => {
      // FIXED: Ensure page updates correctly
      if (action === "changePage") {
        setCurrentPage(tableState.page + 1);
      }
      if (action === "changeRowsPerPage") {
        setRowsPerPage(tableState.rowsPerPage);
        setCurrentPage(1);
      }
    },
    textLabels: { body: { noMatch: loading ? "Loading trips..." : "No trips found" } },
  };

  const getTheme = () => createTheme({
    palette: { primary: { main: "#2196f3" } },
    typography: { fontFamily: "Roboto, Helvetica, Arial, Sans-serif" },
  });

  return (
    <>
      <StatusAlert open={alertOpen} setOpen={setAlertOpen} message={alertMessage} severity={alertSeverity} />

      <HeaderTrips
        searchValue={searchValue}
        handleSearchChange={handleSearchChange}
        searchInputRef={searchInputRef}
        statusFilter={statusFilter}
        setStatusFilter={(val) => { setStatusFilter(val); setCurrentPage(1); }}
        dateFilterType={dateFilterType}
        setDateFilterType={(val) => { setDateFilterType(val); setCurrentPage(1); }}
        selectedStartDate={selectedStartDate}
        setSelectedStartDate={setSelectedStartDate}
        selectedEndDate={selectedEndDate}
        setSelectedEndDate={setSelectedEndDate}
        showStatusDropdown={showStatusDropdown}
        setShowStatusDropdown={setShowStatusDropdown}
        showDateDropdown={showDateDropdown}
        setShowDateDropdown={setShowDateDropdown}
        handleDateRangeApply={handleDateRangeApply}
        clearFilters={clearFilters}
        statusOptions={statusOptions}
        datePresets={datePresets}
        getDateRangeLabel={getDateRangeLabel}
      />

      {/* Loading UI */}
      {loading && (
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          py: 8,
          gap: 2
        }}>
          <CircularProgress size={60} sx={{ color: '#2196f3' }} />
          <Typography variant="h6" sx={{ color: '#666', fontWeight: 500 }}>
            {loadingStage === 'fetching' && '📡 Fetching Trip Data...'}
            {loadingStage === 'analyzing' && '📊 Analyzing Trip Information...'}
            {loadingStage === 'rendering' && '🎨 Preparing Display...'}
          </Typography>
          <Typography variant="body2" sx={{ color: '#999' }}>
            {isTestUser ? 'Loading latest 5 trips' : 'Loading trips data'}
          </Typography>
        </Box>
      )}

      {!loading && (
        <>
      <Divider />
      <Box sx={{ maxWidth: "100%", padding: "0 24px 24px 24px", background: "white" }}>
        <Box sx={{ display: "flex", justifyContent: "flex-start", mb: 2, pt: 2 }}>
          <Button
            variant="contained"
            onClick={() => setOpenAddTrip(true)}
            sx={{
              backgroundColor: "#fff9c4",
              color: "#000",
              fontWeight: 800, // Make text bolder
              textTransform: "none",
              padding: "10px 32px",
              fontSize: "16px",
              boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
              "&:hover": { backgroundColor: "#fff59d", boxShadow: "0 6px 8px rgba(0,0,0,0.15)" },
            }}
          >
            Add Trip
          </Button>
        </Box>
        <ThemeProvider theme={getTheme()}>
          <MUIDataTable title={null} data={tripsData} columns={columns} options={options} />
        </ThemeProvider>
      </Box>

      <Dialog
        open={openAddTrip}
        onClose={() => setOpenAddTrip(false)}
        maxWidth="sm"
        fullWidth
        TransitionComponent={Transition}
        PaperProps={{ style: { backgroundColor: '#fff', color: '#000' } }}
      >
        <DialogTitle sx={{ fontWeight: 700, borderBottom: '1px solid #e0e0e0', mb: 2, color: '#000' }}>Add New Trip</DialogTitle>
        <DialogContent>
          <Grid container spacing={3} sx={{ mt: 0.5 }}>
            <Grid item xs={12}>
              <Autocomplete
                options={clients}
                getOptionLabel={(option) => `${option.company_name || ''}`}
                isOptionEqualToValue={(option, value) => option.id === value?.id || option.user_id === value?.user_id}
                componentsProps={{ paper: { sx: { bgcolor: '#fff', color: '#000' } } }}
                loading={loadingClients}
                onOpen={() => {
                  if (clients.length === 0) fetchClients("");
                }}
                onInputChange={(e, newInputValue) => fetchClients(newInputValue)}
                onChange={(e, newValue) => {
                  setSelectedClient(newValue);
                  setAddTripData({ ...addTripData, user_id: newValue ? newValue.user_id : "" });
                  if (newValue) {
                    fetchDrivers(newValue.user_id);
                  } else {
                    setDrivers([]);
                    setSelectedDriver(null);
                  }
                }}
                renderOption={(props, option) => {
                  const { key, ...otherProps } = props;
                  return (
                    <li key={key} {...otherProps}>
                      <Box display="flex" flexDirection="column">
                        <Typography variant="body1" sx={{ fontWeight: 500, color: '#000' }}>{option.company_name}</Typography>
                        <Typography variant="caption" sx={{ color: '#666' }}>{option.user_id}</Typography>
                      </Box>
                    </li>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Client"
                    variant="outlined"
                    fullWidth
                    InputLabelProps={{ style: { color: "#666" } }}
                    sx={{ '& .MuiOutlinedInput-root fieldset': { borderColor: '#b0b0b0' } }}
                    InputProps={{
                      ...params.InputProps,
                      style: { color: "#000" },
                      endAdornment: (
                        <React.Fragment>
                          {loadingClients ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      ),
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                options={drivers}
                getOptionLabel={(option) => `${option.username || ''}`}
                isOptionEqualToValue={(option, value) => option.user_id === value?.user_id}
                componentsProps={{ paper: { sx: { bgcolor: '#fff', color: '#000' } } }}
                loading={loadingDrivers}
                disabled={!selectedClient}
                value={selectedDriver}
                onChange={(e, newValue) => {
                  setSelectedDriver(newValue);
                  setAddTripData({ ...addTripData, driver_id: newValue ? newValue.user_id : "" });
                }}
                onOpen={() => {
                  if (drivers.length === 0 && selectedClient) fetchDrivers(selectedClient.user_id);
                }}
                renderOption={(props, option) => {
                  const { key, ...otherProps } = props;
                  return (
                    <li key={key} {...otherProps}>
                      <Box display="flex" alignItems="center" width="100%">
                        <img
                          src={option.image && option.image !== 'non' ? `${config.apiImageUrl}${option.image}` : `https://ui-avatars.com/api/?name=${encodeURIComponent(option.username || 'D')}&background=random`}
                          alt="driver"
                          style={{ width: 40, height: 40, borderRadius: '50%', marginRight: 15, objectFit: 'cover' }}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(option.username || 'D')}&background=random`;
                          }}
                        />
                        <Box>
                          <Typography variant="body1" sx={{ fontWeight: 500, color: '#000' }}>{option.username}</Typography>
                          <Typography variant="caption" sx={{ color: '#666' }}>{option.user_id}</Typography>
                        </Box>
                      </Box>
                    </li>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Driver"
                    variant="outlined"
                    fullWidth
                    InputLabelProps={{ style: { color: "#666" } }}
                    sx={{ '& .MuiOutlinedInput-root fieldset': { borderColor: '#b0b0b0' } }}
                    InputProps={{ ...params.InputProps, style: { color: "#000" } }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Vehicle No"
                fullWidth
                variant="outlined"
                value={addTripData.vehicle_id}
                onChange={(e) => setAddTripData({ ...addTripData, vehicle_id: e.target.value })}
                InputLabelProps={{ style: { color: "#666" } }}
                sx={{ '& .MuiOutlinedInput-root fieldset': { borderColor: '#b0b0b0' } }}
                InputProps={{ style: { color: "#000" } }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Autocomplete
                options={startLocOptions}
                onInputChange={(e, val) => searchCities(val, setStartLocOptions, setLoadingStartLoc)}
                componentsProps={{ paper: { sx: { bgcolor: '#fff', color: '#000' } } }}
                onChange={(e, val) => setAddTripData({ ...addTripData, start_location: val || "" })}
                freeSolo
                renderInput={(params) => (
                  <TextField {...params} label="Start Location" fullWidth variant="outlined"
                    onChange={(e) => setAddTripData({ ...addTripData, start_location: e.target.value })}
                    InputLabelProps={{ style: { color: "#666" } }}
                    sx={{ '& .MuiOutlinedInput-root fieldset': { borderColor: '#b0b0b0' } }}
                    InputProps={{
                      ...params.InputProps,
                      style: { color: "#000" },
                      endAdornment: (
                        <React.Fragment>
                          {loadingStartLoc ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      ),
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Autocomplete
                options={endLocOptions}
                onInputChange={(e, val) => searchCities(val, setEndLocOptions, setLoadingEndLoc)}
                componentsProps={{ paper: { sx: { bgcolor: '#fff', color: '#000' } } }}
                onChange={(e, val) => setAddTripData({ ...addTripData, end_location: val || "" })}
                freeSolo
                renderInput={(params) => (
                  <TextField {...params} label="End Location" fullWidth variant="outlined"
                    onChange={(e) => setAddTripData({ ...addTripData, end_location: e.target.value })}
                    InputLabelProps={{ style: { color: "#666" } }}
                    sx={{ '& .MuiOutlinedInput-root fieldset': { borderColor: '#b0b0b0' } }}
                    InputProps={{
                      ...params.InputProps,
                      style: { color: "#000" },
                      endAdornment: (
                        <React.Fragment>
                          {loadingEndLoc ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      ),
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Start Date"
                type="date"
                fullWidth
                variant="outlined"
                InputLabelProps={{ shrink: true, style: { color: "#666" } }}
                sx={{ '& .MuiOutlinedInput-root fieldset': { borderColor: '#b0b0b0' } }}
                InputProps={{ style: { color: "#000" } }}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val) {
                    const formattedDate = format(new Date(val), "MMM dd yyyy").toUpperCase();
                    setAddTripData({ ...addTripData, start_date: formattedDate });
                  } else {
                    setAddTripData({ ...addTripData, start_date: "" });
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Start Time"
                type="time"
                fullWidth
                variant="outlined"
                InputLabelProps={{ shrink: true, style: { color: "#666" } }}
                sx={{ '& .MuiOutlinedInput-root fieldset': { borderColor: '#b0b0b0' } }}
                InputProps={{ style: { color: "#000" } }}
                onChange={(e) => setAddTripData({ ...addTripData, time: e.target.value })}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 2, borderTop: '1px solid #e0e0e0' }}>
          <Button onClick={() => setOpenAddTrip(false)} color="inherit" sx={{ fontWeight: 600, color: '#000' }}>Cancel</Button>
          <Button onClick={handleAddTripSubmit} variant="contained" color="primary" disabled={savingTrip} sx={{ fontWeight: 600, ml: 2, color: '#fff' }}>
            {savingTrip ? "Saving..." : "Save"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* FIXED: Single Menu anchored to the active row */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
      >
        <MenuItem
          onClick={() => {
            if (activeRow) {
              navigate(`/trip_details/${activeRow.id}`, {
                state: { driver_id: activeRow.driver_id }
              });
            }
            handleCloseMenu();
          }}
        >
          <RemoveRedEyeIcon sx={{ mr: 1, fontSize: 18 }} /> View More
        </MenuItem>
      </Menu>
        </>
      )}
    </>
  );
}

export default Trips;